import { RequestStatus, RequestTypes, ShiftSegmentTypeName } from "../../../Enums"
import i18n from '../../../../i18n';
import { getAsStartAndEndTimeFormat, formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';

/**
 *
 * @param {RequestStatus} status
 * @param {string} approvedByManagerName
 * @returns {string}
 */
export const GetModifiedBy = (status, approvedByManagerName) => status === RequestStatus.Approved && approvedByManagerName === "" ? i18n.t('employmentBillboard:approvalType.autoApproval') : approvedByManagerName;

export const getChipClass = (rowData, classes) => {
    switch (rowData.actionType) {
        case RequestTypes.toCover:
            return classes.chipTC;
        case RequestTypes.shiftSwap:
            return classes.chipSS;
        case RequestTypes.openShift:
            return classes.chipOS;
        case RequestTypes.voluntaryTimeOff:
            return classes.chipVTO;
        default:
            return '';
    }
};

export const generateShiftColors = (status, actionType, isEeTo) => {
    let color = {};
    switch (status) {
        case 'Refused':
        case 'Submitted':
        case 'Pending':
        case 'Retracted':
            color.bgColor = '#FFF';
            color.color = '#333';
            color.borderColor = '#0A54A2';
            switch (actionType) {
                case RequestTypes.toCover:
                    color.borderColor = isEeTo ? '#ffdd00' : '#0A54A2';
                    break;
                case RequestTypes.shiftSwap:
                    color.borderColor = isEeTo ? '#FF7A59' : '#0A54A2';
                    break;
                case RequestTypes.openShift:
                    color.borderColor = '#EE0F0F';
                    break;
                case RequestTypes.voluntaryTimeOff:
                    color.borderColor = '#006600';
                    break;
                default:
                    break;
            }
            break;
        case 'Approved':
            color.bgColor = '#FFF';
            color.borderColor = '#0A54A2';
            color.color = '#7a7a7a';
            if (actionType === RequestTypes.voluntaryTimeOff) {
                color.borderColor = '#006600';
            }
            break;
        default:
            color = {
                color: '#48D960',
                bgColor: 'transparent',
                borderColor: '#0A54A2',
            };
    }
    return color;
};

export const generateSchedule = (rowData, type) => {
    const generateScheduleTitle = (shift, transferSegment) => `${(shift.label ? `${shift.label} ` : '')}${getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}${(transferSegment ? ' (x)' : '')}`;

    let shiftOffer, proposalOffer, shiftOffers, paycodes;
    let schedule = [];
    let status;
    let shiftOfferStartDateTimeInISO;
    let shiftProposalStartDateTimeInISO;
    switch (rowData.actionType) {
        case RequestTypes.toCover:
            status = rowData.status.label;
            shiftOffer = rowData.shift;
            if (rowData.isPartial) {
                shiftOffer = rowData.partialShift;
            }
            shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
            break;
        case RequestTypes.shiftSwap:
            status = rowData.status.label;
            shiftOffer = rowData.swapRequestShiftInfo[0].shift;
            proposalOffer = rowData.swapProposalShiftInfo[0].shift;
            if (rowData.isPartialOffer) {
                shiftOffer = rowData.partialOfferShift;
            }
            if (rowData.isPartialProposal) {
                proposalOffer = rowData.partialProposalShift;
            }
            shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
            shiftProposalStartDateTimeInISO = formatAs(proposalOffer.startDateTime, DateFnsFormats.ISO);
            break;
        case RequestTypes.openShift:
            status = rowData.status.label;
            shiftOffer = rowData.shift;
            if (rowData.isPartial) {
                shiftOffer = rowData.partialShift;
            }
            shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
            break;
        case RequestTypes.voluntaryTimeOff:
            status = rowData.status.label;
            shiftOffers = rowData.shifts.map(x => x.shift);
            shiftOffer = { id: -1, label: "Not used" };
            paycodes = rowData.paycodes || [];
            paycodes.forEach(pc => {
                pc.startDateTime = pc.startDate;
                pc.endDateTime = pc.endDate;
            });
            break;
        default:
            break;
    }

    let color = generateShiftColors(status, rowData.actionType, type === 'to');

    switch (status) {
        case 'Approved':
            if (type === 'from') {
                let employeeFromShifts = rowData.employeeFromSchedule;
                for (let shift of employeeFromShifts) {
                    const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                    const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                            schedule.push({
                                id: shift.id,
                                calendarId: '0',
                                title: generateScheduleTitle(shift, transferSegment),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftStartDateTimeInISO,
                                end: shiftStartDateTimeInISO,
                                customStyle: 'padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...shift,
                                    status: rowData.status.value
                                },
                            });
                            break;
                        default:
                            break;
                    }
                }
                switch (rowData.actionType) {
                    case RequestTypes.toCover:
                    case RequestTypes.shiftSwap:
                    case RequestTypes.openShift:
                        const transferSegment = shiftOffer.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                        const shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                        schedule.push({
                            id: shiftOffer.id,
                            calendarId: '1',
                            title: generateScheduleTitle(shiftOffer, transferSegment),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftOfferStartDateTimeInISO,
                            end: shiftOfferStartDateTimeInISO,
                            customStyle: 'border: 1px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: {
                                ...shiftOffer,
                                status: rowData.status.value
                            },
                            color: color.color,
                            bgColor: color.bgColor,
                            borderColor: color.borderColor
                        });
                        break;
                    default:
                        break;
                }
            }
            else {
                let employeeToShifts = rowData.employeeToSchedule;
                for (let shift of employeeToShifts) {
                    const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                    const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                    switch (rowData.actionType) {
                        case RequestTypes.toCover:
                        case RequestTypes.shiftSwap:
                        case RequestTypes.openShift:
                        case RequestTypes.voluntaryTimeOff:
                            schedule.push({
                                id: shift.id,
                                calendarId: '0',
                                title: generateScheduleTitle(shift, transferSegment),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftStartDateTimeInISO,
                                end: shiftStartDateTimeInISO,
                                customStyle: 'padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...shift,
                                    status: rowData.status.value
                                }
                            });
                            break;
                        default:
                            break;
                    }
                }
                switch (rowData.actionType) {
                    case RequestTypes.toCover:
                    case RequestTypes.shiftSwap:
                    case RequestTypes.openShift:
                        const shiftOfferStartDateTimeInISO = formatAs(shiftOffer.startDateTime, DateFnsFormats.ISO);
                        schedule.push({
                            id: shiftOffer.id,
                            calendarId: '1',
                            title: generateScheduleTitle(shiftOffer, false),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftOfferStartDateTimeInISO,
                            end: shiftOfferStartDateTimeInISO,
                            customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: {
                                ...shiftOffer,
                                status: rowData.status.value
                            },
                            bgColor: color.bgColor,
                            borderColor: color.borderColor
                        });
                        break;
                    case RequestTypes.voluntaryTimeOff:
                        for (const paycode of paycodes) {
                            if (paycode?.payCodeRef) {
                                schedule.push({
                                    id: paycode.id,
                                    calendarId: '2',
                                    title: paycode.payCodeRef.qualifier,
                                    category: 'time',
                                    dueDateClass: '',
                                    start: formatAs(paycode.startDateTime, DateFnsFormats.ISO),
                                    end: formatAs(paycode.endDateTime, DateFnsFormats.ISO),
                                    customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: paycode,
                                    color: '#7a7a7a',
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                });
                            }
                        }
                        for (const offer of shiftOffers) {
                            const offerStartDateTimeInISO = formatAs(offer.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: offer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(offer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: offerStartDateTimeInISO,
                                end: offerStartDateTimeInISO,
                                customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: {
                                    ...offer,
                                    status: rowData.status.value
                                },
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            });
                        }
                        break;
                    default:
                        break;
                }
            }
            break;
        case 'Refused':
        case 'Submitted':
        case 'Pending':
        case 'Retracted':
        default:
            if (type === 'from') {
                let employeeFromShifts = rowData.employeeFromSchedule;
                for (let shift of employeeFromShifts) {
                    if (shift.id !== shiftOffer.id) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        schedule.push({
                            id: shift.id,
                            calendarId: '0',
                            title: generateScheduleTitle(shift, transferSegment),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftStartDateTimeInISO,
                            end: shiftStartDateTimeInISO,
                            customStyle: 'border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: shift
                        });
                    }
                }
                schedule.push({
                    id: shiftOffer.id,
                    calendarId: '1',
                    title: generateScheduleTitle(shiftOffer, false),
                    category: 'time',
                    dueDateClass: '',
                    start: shiftOfferStartDateTimeInISO,
                    end: shiftOfferStartDateTimeInISO,
                    customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                    isReadOnly: true,
                    raw: shiftOffer,
                    bgColor: color.bgColor,
                    borderColor: color.borderColor
                });
                if (rowData.actionType === RequestTypes.shiftSwap) {
                    const proposalOfferColor = generateShiftColors(status, rowData.actionType, true);
                    schedule.push({
                        id: proposalOffer.id,
                        calendarId: '1',
                        title: generateScheduleTitle(proposalOffer, false),
                        category: 'time',
                        dueDateClass: '',
                        start: shiftProposalStartDateTimeInISO,
                        end: shiftProposalStartDateTimeInISO,
                        customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                        isReadOnly: true,
                        raw: proposalOffer,
                        color: '#7a7a7a',
                        bgColor: proposalOfferColor.bgColor,
                        borderColor: proposalOfferColor.borderColor
                    });
                }
            }
            else {
                let employeeToShifts = rowData.employeeToSchedule;
                for (let shift of employeeToShifts) {
                    if (shift.id !== shiftOffer.id) {
                        const transferSegment = shift.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
                        const shiftStartDateTimeInISO = formatAs(shift.startDateTime, DateFnsFormats.ISO);
                        schedule.push({
                            id: shift.id,
                            calendarId: '0',
                            title: generateScheduleTitle(shift, transferSegment),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftStartDateTimeInISO,
                            end: shiftStartDateTimeInISO,
                            customStyle: 'padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: shift
                        });
                    }
                }
                switch (rowData.actionType) {
                    case RequestTypes.toCover:
                    case RequestTypes.openShift:
                        schedule.push({
                            id: shiftOffer.id,
                            calendarId: '1',
                            title: generateScheduleTitle(shiftOffer, false),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftOfferStartDateTimeInISO,
                            end: shiftOfferStartDateTimeInISO,
                            customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: shiftOffer,
                            color: '#7a7a7a',
                            bgColor: color.bgColor,
                            borderColor: color.borderColor
                        });
                        break;
                    case RequestTypes.shiftSwap:
                        schedule.push({
                            id: shiftOffer.id,
                            calendarId: '1',
                            title: generateScheduleTitle(shiftOffer, false),
                            category: 'time',
                            dueDateClass: '',
                            start: shiftOfferStartDateTimeInISO,
                            end: shiftOfferStartDateTimeInISO,
                            customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                            isReadOnly: true,
                            raw: shiftOffer,
                            color: '#7a7a7a',
                            bgColor: color.bgColor,
                            borderColor: color.borderColor
                        });
                        {
                            const proposalOfferColor = generateShiftColors(status, rowData.actionType, false);
                            schedule.push({
                                id: proposalOffer.id,
                                calendarId: '1',
                                title: generateScheduleTitle(proposalOffer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: shiftProposalStartDateTimeInISO,
                                end: shiftProposalStartDateTimeInISO,
                                customStyle: 'border: 2px solid #e1e1e1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: proposalOffer,
                                bgColor: proposalOfferColor.bgColor,
                                borderColor: proposalOfferColor.borderColor
                            });
                        }
                        break;
                    case RequestTypes.voluntaryTimeOff:
                        for (const paycode of paycodes) {
                            if (paycode?.payCodeRef) {
                                schedule.push({
                                    id: paycode.id,
                                    calendarId: '2',
                                    title: paycode.payCodeRef.qualifier,
                                    category: 'time',
                                    dueDateClass: '',
                                    start: formatAs(paycode.startDateTime, DateFnsFormats.ISO),
                                    end: formatAs(paycode.endDateTime, DateFnsFormats.ISO),
                                    customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                    isReadOnly: true,
                                    raw: paycode,
                                    color: '#7a7a7a',
                                    bgColor: color.bgColor,
                                    borderColor: color.borderColor
                                });
                            }
                        }
                        for (const offer of shiftOffers) {
                            const offerStartDateTimeInISO = formatAs(offer.startDateTime, DateFnsFormats.ISO);
                            schedule.push({
                                id: offer.id,
                                calendarId: '0',
                                title: generateScheduleTitle(offer, false),
                                category: 'time',
                                dueDateClass: '',
                                start: offerStartDateTimeInISO,
                                end: offerStartDateTimeInISO,
                                customStyle: 'border: 2px solid #f1f1f1; border-radius: 2px; padding-left: 5px; padding-right: 5px;',
                                isReadOnly: true,
                                raw: offer,
                                color: '#7a7a7a',
                                bgColor: color.bgColor,
                                borderColor: color.borderColor
                            });
                        }
                        break;
                    default:
                        break;
                }
            }
            break;
    }
    return schedule;
};